module.exports = __webpack_public_path__ + "static/img/home-service3.990ff234.png";